import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'dropdown-container',
    templateUrl: './dropdown-container.component.html',
    styleUrls: ['./dropdown-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DropdownContainerComponent {

}
